import { t } from "@/locales/vue";
import { isValidEmail } from "@/utils/rules/rules";

const rules = {
  email: [
    (val: string) => !!val || t("pages.auth.rules.email-missing"),
    (val: string) => isValidEmail(val) || t("pages.auth.rules.email-invalid"),
  ],
  empty: (name: string, addPrefix = true) => [
    (val: string) => (val !== null && val !== "") || `${addPrefix ? t("pages.auth.rules.name-missing") : ""} ${name}`,
  ],
  termsOfUse: [(val: boolean) => !!val || t("pages.auth.rules.terms-of-use")],
};

export default rules;
